import { render, staticRenderFns } from "./tagging.vue?vue&type=template&id=18ba2d01&scoped=true&lang=pug&"
import script from "./tagging.vue?vue&type=script&lang=js&"
export * from "./tagging.vue?vue&type=script&lang=js&"
import style0 from "./tagging.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tagging.vue?vue&type=style&index=1&id=18ba2d01&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba2d01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ba2d01')) {
      api.createRecord('18ba2d01', component.options)
    } else {
      api.reload('18ba2d01', component.options)
    }
    module.hot.accept("./tagging.vue?vue&type=template&id=18ba2d01&scoped=true&lang=pug&", function () {
      api.rerender('18ba2d01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/tagging.vue"
export default component.exports